import { lowerFDI, upperFDI } from '@/common/FDI_Notation';
import type ToothCorrection from './ToothCorrection';

export type ArchNeighbors = {
  mesial: ToothCorrection | null;
  distal: ToothCorrection | null;
};

/** Mesial/distal neighbors of `active` along the FDI arch order. */
export function getMesialDistalNeighbors(
  active: ToothCorrection,
  teeth: ToothCorrection[],
  jawType: 'upper' | 'lower',
): ArchNeighbors {
  const order = jawType === 'upper' ? upperFDI : lowerFDI;
  const fdi = active.getFDI();
  const idx = order.indexOf(fdi as (typeof order)[number]);
  if (idx === -1) return { mesial: null, distal: null };

  const find = (targetFdi: number) => teeth.find((t) => t.getFDI() === targetFdi) ?? null;

  // Mesial = toward midline: higher index on right quadrants (18–11, 38–31), lower on left (21–28, 41–48).
  const isRightQuadrant = idx < 8;
  const mesialIdx = isRightQuadrant ? idx + 1 : idx - 1;
  const distalIdx = isRightQuadrant ? idx - 1 : idx + 1;

  const mesialFdi = mesialIdx >= 0 && mesialIdx < order.length ? order[mesialIdx] : null;
  const distalFdi = distalIdx >= 0 && distalIdx < order.length ? order[distalIdx] : null;

  return {
    mesial: mesialFdi != null ? find(mesialFdi) : null,
    distal: distalFdi != null ? find(distalFdi) : null,
  };
}
